// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Link from "@insite/mobius/Icons/Link";
import { RadioStyle } from "@insite/mobius/Radio";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { locationSearchResultsStyles } from "@steiner/App/Components/LocationFinder/LocationSearchResults";
import { color } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

locationSearchResultsStyles.searchContainer = {
    css: css`
        display: grid;
        height: 642px;
        grid-template-rows: auto 1fr auto;
    `,
};

locationSearchResultsStyles.searchInputGridContainer = {
    gap: 10,
    css: css`
        background: ${color("primary")};
        padding: 5px 15px;
        color: ${color("common.white")};
    `,
};

locationSearchResultsStyles.searchResultsText = {
    color: "common.white",
    size: 14,
};

locationSearchResultsStyles.searchResultsTextGridItem = {
    width: 6,
    css: css`
        align-items: center;
    `,
};
locationSearchResultsStyles.distanceUnitOfMeasureGridItem = {
    width: 6,
    css: css`
        align-items: center;
    `,
};

locationSearchResultsStyles.distanceUnitOfMeasureRadioGroup = {
    css: css`
        display: inline-block;
        width: 100%;
        flex-direction: row;
        text-align: right;
        & > div {
            display: inline-flex;
        }
    
        ${RadioStyle}:first-of-type {
            margin-right:12px;
        }
        ${RadioStyle} + ${RadioStyle} {
            margin-top: 0;
        }

        & > ${TypographyStyle} {
            margin-bottom: 8px;
        }
    `,
};

locationSearchResultsStyles.searchResultRow = {
    css: css`
        overflow-y: auto;
        overflow-x: hidden;
        border: 2px solid ${color("common.border")};
        border-top: none;
    `,
};

locationSearchResultsStyles.searchResultGridItem = {
    width: 12,
    css: css`
        padding: 10px 15px;
        &:first-child {
            margin-top: 5px;
        }
        &:not(:last-child) {
            border-bottom: 1px solid ${color("common.border")};
        }
    `,
};

locationSearchResultsStyles.searchResultContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        padding: 10px 15px;
        border-bottom: 1px solid ${color("common.border")};
    `,
};

locationSearchResultsStyles.searchResultContentWrapper = {
    css: css`
        display: flex;
    `,
};

locationSearchResultsStyles.searchResultLeftContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        flex: 1;
    `,
};

locationSearchResultsStyles.searchResultRightContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        gap: 4px;
    `,
};

locationSearchResultsStyles.locationDistanceDisplayText = {
    css: css`
        align-self: flex-end;
        font-size: 12px;
        line-height: 18px;
    `,
};

locationSearchResultsStyles.locationDisplayNumberText = {
    color: "primary",
    weight: "bold",
    css: css`
        font-size: 15px;
        margin-right: 10px;
    `,
};

locationSearchResultsStyles.locationNameLink = {
    color: "primary",
    typographyProps: {
        weight: "bold",
        ellipsis: true,
        css: css`
            font-size: 14px;
            line-height: 20px;
        `,
    },
};

locationSearchResultsStyles.locationAddressInfoCondensed = {
    wrapper: {
        css: css`
            font-size: 14px;
            line-height: 20px;
        `,
    },
};

locationSearchResultsStyles.searchResultPhoneLink = {
    typographyProps: {
        css: css`
            font-size: 14px;
            line-height: 20px;
        `,
    },
};

locationSearchResultsStyles.locationContentLink = {
    typographyProps: {
        css: css`
            font-size: 12px;
            line-height: 18px;
        `,
    },
};

locationSearchResultsStyles.locationGoogleMapsDirectionLink = {
    icon: {
        iconProps: {
            src: Link,
            size: 12,
            css: css`
                margin-right: 4px;
            `,
        },
        position: "left",
    },
    typographyProps: {
        css: css`
            font-size: 12px;
            line-height: 12px;
        `,
    },
};
